<template>
  <form
    class="c-navbar-search"
    @submit.prevent=""
    @keydown.esc="close"
  >
    <i
      v-accessibility-focus="toggle"
      class="o-icon o-icon--search o-typography--action c-navbar-search__icon"
      :aria-label="$t('accessibility.search.open')"
    ></i>
    <v-input
      ref="searchInput"
      v-model="inputValue"
      class="c-navbar-search__input"
      :tabindex="isContentFocusable"
      :aria-label="$t('accessibility.search.input')"
      @input="input"
    ></v-input>
    <i
      v-accessibility-focus="close"
      class="o-icon o-icon--close o-typography--action c-navbar-search__close"
      :aria-label="$t('accessibility.search.close')"
      :tabindex="isContentFocusable"
    ></i>
  </form>
</template>
<script>
  import debounce from 'lodash/debounce';
  import { VInput } from '@/index/shared/components/index';
  import { searchMixin } from '@/index/shared/mixins';
  import { TabIndex } from '@/shared/enums';

  const DEBOUNCE_DELAY = 300;

  export default {
    components: {
      VInput,
    },
    mixins: [
      searchMixin,
    ],
    props: {
      initialSearchValue: String,
      searchVisible: Boolean,
    },
    enums: {
      TabIndex,
    },
    data() {
      return {
        inputValue: undefined,
      };
    },
    computed: {
      isContentFocusable() {
        return this.searchVisible ? TabIndex.ENABLED : TabIndex.DISABLED;
      },
    },
    watch: {
      $route: 'load',
      initialSearchValue: 'refreshValue',
      inputValue: 'emitInput',
    },
    created() {
      this.input = debounce(this.input, DEBOUNCE_DELAY);
    },
    mounted() {
      this.load();
    },
    beforeDestroy() {
      this.input.cancel();
    },
    methods: {
      emitInput() {
        this.$emit('input', this.inputValue);
      },
      refreshValue() {
        this.inputValue = this.initialSearchValue;
      },
      close() {
        if (this.isSearchView) {
          this.$router.goBack();
        } else {
          this.inputValue = '';
          this.toggle();
        }
      },
      load() {
        if (this.isSearchView && !this.searchVisible) {
          this.inputValue = this.$route.query.query;
          this.toggle();
        } else if (!this.isSearchView && this.searchVisible) {
          this.toggle();
          this.inputValue = '';
        }
      },
      toggle() {
        if (!this.searchVisible) {
          this.$refs.searchInput.$refs.input.focus();
        }
        this.$emit('toggle');
      },
      input() {
        if (!this.inputValue || this.inputValue.length < 3) {
          return;
        }

        this.search(this.inputValue);
      },
    },
  };
</script>
